/**
 * Formats a date string or Date object to a readable format with day, month name, year, and time.
 * Uses en-GB locale for day-month-year order (e.g., "24 February 2026, 14:30").
 *
 * @param date - The date string or Date object to format
 * @returns The formatted date string
 *
 * @example
 * formatDateWithMonthName("2026-02-24T14:30:00Z") // "24 February 2026, 14:30"
 * formatDateWithMonthName(new Date()) // Current date in format "24 February 2026, 14:30"
 */
export function formatDateWithMonthName(date: string | Date): string {
  const dateObj = (() => {
    if (typeof date === "string") {
      return new Date(date);
    }
    return date;
  })();
  return dateObj.toLocaleString("en-GB", {
    year: "numeric",
    month: "long",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  });
}

/**
 * Formats a date string or Date object to a numeric format with day, month, year, and time.
 * Uses en-GB locale for DD/MM/YYYY order (e.g., "14/07/2025, 19:16").
 *
 * @param date - The date string or Date object to format
 * @returns The formatted date string
 *
 * @example
 * formatDateNumeric("2025-07-14T19:16:00Z") // "14/07/2025, 19:16"
 * formatDateNumeric(new Date()) // Current date in format "24/02/2026, 14:30"
 */
export function formatDateNumeric(date: string | Date): string {
  const dateObj = (() => {
    if (typeof date === "string") {
      return new Date(date);
    }
    return date;
  })();
  return dateObj.toLocaleString("en-GB", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  });
}
